import { GridColumnSettings } from '@/shared/types/grid';

export const idColumn = <T extends { id: string }>(): GridColumnSettings<T> => {
  return {
    uid: 'id',
    field: 'id',
    isPrimaryKey: true,
    visible: false,
    showInColumnChooser: false,
    allowSorting: false,
    allowFiltering: false,
  };
};
